var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagTajikistan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.58763 9.05538C0.5705 11.1589 0 13.5188 0 16.0119C0 18.505 0.5705 20.8649 1.58763 22.9684L16 24.3597L30.4124 22.9684C31.4295 20.8649 32 18.505 32 16.0119C32 13.5188 31.4295 11.1589 30.4124 9.05538L16 7.66406L1.58763 9.05538Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.58789 22.9683C4.17583 28.3201 9.65639 32.0118 15.9997 32.0118C22.343 32.0118 27.8236 28.3201 30.4115 22.9683H1.58789Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.58789 9.05522H30.4115C27.8236 3.70334 22.343 0.0117188 15.9997 0.0117188C9.65639 0.0117188 4.17583 3.70334 1.58789 9.05522Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2178 20.1853H18.7831V17.8201L17.67 18.3766L16.0005 16.707L14.3309 18.3766L13.2178 17.8201V20.1853Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0337 17.4028L10.2928 18.2H11.1309L10.4528 18.6926L10.7118 19.4898L10.0337 18.9971L9.35559 19.4898L9.61465 18.6926L8.93652 18.2H9.77465L10.0337 17.4028Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8364 14.6201L11.0955 15.4172H11.9336L11.2555 15.9099L11.5145 16.7071L10.8364 16.2144L10.1583 16.7071L10.4174 15.9099L9.73926 15.4172H10.5774L10.8364 14.6201Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1325 12.5332L13.3916 13.3303H14.2297L13.5517 13.823L13.8106 14.6201L13.1325 14.1275L12.4545 14.6201L12.7135 13.823L12.0353 13.3303H12.8735L13.1325 12.5332Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9672 17.4028L21.7082 18.2H20.87L21.5482 18.6926L21.2891 19.4898L21.9672 18.9971L22.6453 19.4898L22.3863 18.6926L23.0644 18.2H22.2263L21.9672 17.4028Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1646 14.6201L20.9055 15.4172H20.0674L20.7455 15.9099L20.4864 16.7071L21.1646 16.2144L21.8427 16.7071L21.5836 15.9099L22.2618 15.4172H21.4236L21.1646 14.6201Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8684 12.5332L18.6093 13.3303H17.7713L18.4493 13.823L18.1903 14.6201L18.8684 14.1275L19.5465 14.6201L19.2875 13.823L19.9655 13.3303H19.1274L18.8684 12.5332Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0004 11.4897L16.2595 12.2869H17.0976L16.4195 12.7796L16.6786 13.5767L16.0004 13.0841L15.3223 13.5767L15.5814 12.7796L14.9033 12.2869H15.7414L16.0004 11.4897Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16632"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0117188)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagTajikistan);
export default __webpack_public_path__ + "static/media/flag_tajikistan.024a5fe1682c80b71783019483b66fee.svg";
export { ForwardRef as ReactComponent };